import { render, staticRenderFns } from "./HomeBg.vue?vue&type=template&id=cfc51ee8&"
import script from "./HomeBg.vue?vue&type=script&lang=js&"
export * from "./HomeBg.vue?vue&type=script&lang=js&"
import style0 from "./HomeBg.vue?vue&type=style&index=0&id=cfc51ee8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports